<template>
<div class="chapter">
<div class="inner_page">
<h2 class="calibre" id="pgepubid00000">PREFACE</h2>
<p class="calibre3"><span class="smcap">Every</span> experienced teacher must have noticed the
difficulty of instructing Indian children out of books
that are specially intended for use in English schools.
It is not merely that the subjects are unfamiliar, but
almost every phrase has English associations that
are strange to Indian ears. The environment in
which they are written is unknown to the Indian
school boy and his mind becomes overburdened with
its details which he fails to understand. He cannot
give his whole attention to the language and thus
master it quickly.</p>
<p class="calibre3">The present Indian story-book avoids some at least
of these impediments. The surroundings described
in it are those of the students' everyday life; the
sentiments and characters are familiar. The stories
are simply told, and the notes at the end will be sufficient
to explain obscure passages. It should be possible
for the Indian student to follow the pages of
the book easily and intelligently. Those students
who have read the stories in the original will have
the further advantage of knowing beforehand the
whole trend of the narrative and thus they will be
able to concentrate their thoughts on the English
language itself.</p>
<p class="calibre3">It is proposed to publish together in a single
volume the original stories whose English translations
are given in this Reader. Versions of the same
stories in the different Indian vernaculars have already
appeared, and others are likely to follow.</p>
<p class="calibre3">Two of the longest stories in this book—"Master
Mashai" and "The Son of Rashmani"—are reproduced
in English for the first time. The rest of
the stories have been taken, with slight revision, from
two English volumes entitled "The Hungry Stones"
and "Mashi." A short paragraph has been added
from the original Bengali at the end of the story
called "The Postmaster." This was unfortunately
omitted in the first English edition.</p>
<p class="calibre3">The list of words to be studied has been chosen
from each story in order to bring to notice different
types of English words. The lists are in no sense
exhaustive. The end in view has been to endeavour
to create an interest in Indian words and their history,
which may lead on to further study.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0002.vue?0f5b70f2